import * as React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import "./i18n";
import { Application } from "./components/Application";
import {
  AdvarraProvider,
  Notifications,
} from "@advarra-engineering/advarra-design-system-react";

const root = createRoot(document.getElementById("app") as HTMLDivElement);
root.render(
  <AdvarraProvider>
    <Application />
    <Notifications position="bottom-right" />
  </AdvarraProvider>,
);
